module.exports = __webpack_public_path__ + "printing-return-label.c05f32eaabfda7c3a733d91e4456e729.svg";